import clsx from "clsx";
import { useEffect, useRef, useState } from "react";
import { removeToast, toast$ } from "./toast.service";
import { ToastData } from "./toast.type";

/** Thông báo thành công ẩn sau 2,4s như bản thiết kế; lỗi / cảnh báo để lâu hơn cho kịp đọc */
const DURATION = { valid: 2400, warn: 4000, inValid: 5000 };

/**
 * Toast kiểu bản thiết kế: viên tối ở giữa, sát đáy màn hình, trượt lên khi hiện.
 * Mỗi lúc chỉ hiện 1 thông báo, thông báo mới thay thông báo cũ.
 * Mọi chỗ gọi addToast() (kể cả code cũ) đều hiện kiểu này; tham số position không còn dùng.
 */
export default function ToastContainer() {
  const [toast, setToast] = useState<ToastData>();
  const [show, setShow] = useState(false);
  const hideTimer = useRef<ReturnType<typeof setTimeout>>();
  const clearTimer = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    const sub = toast$.subscribe((data) => {
      const latest = data.toasts[data.toasts.length - 1];

      if (!latest) return;

      // chỉ giữ thông báo mới nhất trong hàng đợi
      data.toasts.slice(0, -1).forEach((item) => removeToast(item.id));

      clearTimeout(hideTimer.current);
      clearTimeout(clearTimer.current);
      setToast(latest);
      setShow(true);

      hideTimer.current = setTimeout(() => {
        setShow(false);
        // đợi hiệu ứng ẩn xong mới xoá khỏi hàng đợi
        clearTimer.current = setTimeout(() => removeToast(latest.id), 200);
      }, DURATION[latest.status] || DURATION.valid);
    });

    return () => {
      sub.unsubscribe();
      clearTimeout(hideTimer.current);
      clearTimeout(clearTimer.current);
    };
  }, []);

  return (
    <div
      role={toast?.status === "valid" ? "status" : "alert"}
      aria-live="polite"
      className={clsx(
        "pointer-events-none fixed bottom-[calc(24px+env(safe-area-inset-bottom,0px))] left-1/2 z-[100] max-w-[calc(100%-32px)] rounded-[10px] bg-fg px-4 py-2.5 text-[13.5px] font-medium text-surface transition-all duration-200",
        show ? "-translate-x-1/2 translate-y-0 opacity-100" : "-translate-x-1/2 translate-y-5 opacity-0"
      )}
    >
      {toast?.text}
    </div>
  );
}
